// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDL9S0Sg6zV-tr0jetbjdfPNrbU7i3eJX0",
  authDomain: "checkmate-lounge.firebaseapp.com",
  databaseURL: "https://checkmate-lounge-default-rtdb.firebaseio.com",
  projectId: "checkmate-lounge",
  storageBucket: "checkmate-lounge.firebasestorage.app",
  messagingSenderId: "791720865019",
  appId: "1:791720865019:web:71758fe20a5fc2c830545e",
  measurementId: "G-MWS8R42MG2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
